module.exports = __webpack_public_path__ + "img/img60.61322fdf.png";